import { render, staticRenderFns } from "./AdminItems.vue?vue&type=template&id=4a6e2793&scoped=true&"
import script from "./AdminItems.vue?vue&type=script&lang=js&"
export * from "./AdminItems.vue?vue&type=script&lang=js&"
import style0 from "./AdminItems.vue?vue&type=style&index=0&id=4a6e2793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e2793",
  null
  
)

export default component.exports